<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = "https://shop.jptabako.com";
} else {
    // window.location.href = "https://pc.xianmxkj.com";
}
</script>

<style>
.el-input-group__append, .el-input-group__prepend{
    background: #FF2D55!important;
    color: #fff!important;
    border: 1px solid #FF2D55!important;
  }
  .el-input-group--append .el-input__inner, .el-input-group__prepend{
     border: 1px solid #FF2D55!important;
  }
.el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #e5284c!important;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
	background-color: #fff!important;
}
.el-pager li:hover{
	color: #e5284c!important;
}
.el-radio__input.is-checked .el-radio__inner{
		border-color: #FF2D55!important;
		background: #FF2D55!important;
	}
	.el-radio__input.is-checked+.el-radio__label {
	    color: #FF2D55!important;
	}
  * {
	  padding: 0;
	  margin: 0;

  }
  body {
	  background: #f6f5f7;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue